import axios from 'axios';
import { getApiBaseUrl } from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const getPermisosOverride = async (userId) => {
  try {
    const response = await api.get(`users/${userId}/permissions-overrides`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener permisos del usuario: ' + error.message);
  }
};

const getPermisosCatalogo = async () => {
  try {
    const response = await api.get('permissions/catalog');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener catalogo de permisos: ' + error.message);
  }
};

const putPermisosOverride = async (userId, overrides) => {
  try {
    const response = await api.put(`users/${userId}/permissions-overrides`, overrides);
    return response.data;
  } catch (error) {
    throw new Error('Error al guardar permisos del usuario: ' + error.message);
  }
};

export { getPermisosOverride, getPermisosCatalogo, putPermisosOverride };
